import { Phone, Globe, Mail, Facebook, Instagram, Linkedin } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT, SOCIALS } from "../../lib/assets";

const ITEMS = [
  { icon: Phone, label: "Phone", value: CONTACT.phone, href: CONTACT.phoneHref, testid: "contact-phone" },
  { icon: Globe, label: "Website", value: CONTACT.website, href: "https://votezaheer.ca", testid: "contact-website" },
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, testid: "contact-email" },
];

const SOCIAL_LINKS = [
  { icon: Facebook, label: "Facebook", href: SOCIALS.facebook, testid: "social-facebook" },
  { icon: Instagram, label: "Instagram", href: SOCIALS.instagram, testid: "social-instagram" },
  { icon: Linkedin, label: "LinkedIn", href: SOCIALS.linkedin, testid: "social-linkedin" },
];

export const Contact = () => {
  return (
    <section id="contact" className="py-20 lg:py-28 bg-white" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-teal-600">Contact</p>
          <h2 className="font-display font-extrabold tracking-tight text-slate-900 text-3xl md:text-4xl lg:text-5xl mt-3 leading-tight">
            Contact Noman
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {ITEMS.map((it) => (
            <a
              key={it.label}
              href={it.href}
              className="group rounded-2xl border border-slate-200 p-7 hover:-translate-y-1 hover:shadow-lg transition-transform duration-300"
              data-testid={it.testid}
            >
              <div className="inline-flex items-center justify-center rounded-xl bg-teal-50 text-teal-700 p-3 group-hover:bg-teal-600 group-hover:text-white transition-colors">
                <it.icon size={24} strokeWidth={1.75} />
              </div>
              <div className="mt-5 text-xs tracking-[0.18em] uppercase text-slate-400 font-semibold">{it.label}</div>
              <div className="mt-1 font-display text-xl font-bold text-slate-900">{it.value}</div>
            </a>
          ))}
        </div>

        <div className="mt-10 flex items-center gap-4">
          <span className="text-sm font-medium text-slate-500">Follow the campaign</span>
          <div className="flex gap-3">
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="h-11 w-11 inline-flex items-center justify-center rounded-full border border-slate-200 text-slate-600 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-colors"
                data-testid={s.testid}
              >
                <s.icon size={20} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
